import { render, staticRenderFns } from "./mainRegions.vue?vue&type=template&id=08d55ea3&scoped=true&"
import script from "./mainRegions.vue?vue&type=script&lang=js&"
export * from "./mainRegions.vue?vue&type=script&lang=js&"
import style0 from "./mainRegions.vue?vue&type=style&index=0&id=08d55ea3&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08d55ea3",
  null
  
)

export default component.exports